import { GET_TOKEN, GET_REFRESH_TOKEN } from "@/services/local.storage.service";

export default {
  token: GET_TOKEN() ?? null,
  user: null,
  refreshToken: GET_REFRESH_TOKEN() ?? null,
};
